import { FunctionalComponent } from "preact";
import { Route as Home } from "./routes/home";

export const App: FunctionalComponent = () => {
  return <Home />;
};
